/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const DYNAMICBERLIN: CommunityData = {
  code: "dynamicberlin",
  inviteCode: "dynamicberlin",
  name: "Dynamic",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/dyn-033`,
  socials: {},
  styles: {
    global: {
      counterColor: "#03ff00",
      logo: {
        src: "https://media.werz.at/community-assets/dynamicberlin/web-logo.png",
        styles: "w-[140px] h-[116.17px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/dynamicberlin/web-alternative-logo.png",
        styles: "w-[140px] h-[116.17px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "bg-[#000000] border-r border-[#6d6d6d]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/dynamicberlin/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/dynamicberlin/web-background-mobile.jpg",
      nonMemberBg:
        "https://media.werz.at/community-assets/dynamicberlin/web-background-non-member.jpg",
      mainFont: "font-['OpenSansRegular']",
      primaryButton:
        "bg-[#ffffff] border-2 border-[#ffffff] rounded px-[18px] py-[18px] !text-[#000000] font-['OpenSansSemiBold'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "#6a0043",
      item: "text-[#000000] font-['ImpactRegular'] text-[18px] uppercase text-center bg-[#db1086] py-[7px] gap-x-[10px] text-opacity-50 border-b border-[#6a0043] !pl-0 mx-[10px] mb-2",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#000000] !pb-8 overflow-hidden ",
      titles:
        "text-[#03ff00] font-['ImpactRegular'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#a7a7a7] font-['OpenSansRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#6a0043]",
        sectionTitle:
          "text-[#03ff00] font-['ImpactRegular'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['ImpactRegular'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['OpenSansRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#6a0043]",
        sectionTitle:
          "text-[#03ff00] font-['ImpactRegular'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#ffffff] font-['ImpactRegular'] sm:text-[16px] text-left uppercase leading-[110%] mb-2",
          subtitle: "text-[#a7a7a7] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
          location: "text-[#a7a7a7] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
          date: "text-[#a7a7a7] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['ImpactRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OpenSansRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "border border-[#000000]",
        sectionTitle:
          "text-[#03ff00] font-['ImpactRegular'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#6a0043]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['ImpactRegular'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#a7a7a7] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border-2 border-[#ffffff] rounded px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['OpenSansSemiBold'] text-[16px] text-left",
        questions: "text-[14px] text-left leading-[130%] text-[#a7a7a7]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['ImpactRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['ImpactRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border border-[#6d6d6d]",
        mapPinColor: "#000000",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['ImpactRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OpenSansRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['ImpactRegular'] text-[26px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-[#ffffff00] mb-4 overflow-hidden border-b border-[#6a0043] pb-2 sm:pb-4",
          media: "!hidden",
          name: "text-[#ffffff] font-['ImpactRegular'] text-[16px] uppercase text-left leading-[110%]",
          description:
            "text-[#a7a7a7] font-['OpenSansRegular'] text-[14px] text-left leading-[130%] !mt-1",
          price:
            "text-[#a7a7a7] font-['ImpactRegular'] text-[16px] uppercase text-left leading-[110%] !mt-1",
          quantity: "text-[#ffffff] font-['OpenSansSemiBold'] text-[14px] text-left",
          status:
            "text-[#a7a7a7] font-['ImpactRegular'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ffffff] rounded !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#000000] border border-[#ffffff] rounded px-4 py-3 text-[#ffffff] font-['OpenSansSemiBold'] text-[14px] text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default DYNAMICBERLIN
